import { Type } from 'class-transformer';

/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class KladrSubject
 */

export enum KladrContentType {
  REGION = 'region',
  DISTRICT = 'district',
  CITY = 'city',
  STREET = 'street',
  BUILDING = 'building',
}

export class KladrSubject {
  private readonly id!: string;
  private readonly name!: string;
  private readonly zip!: number;
  private readonly type!: string;
  private readonly typeShort!: string;
  private readonly okato!: string;
  private readonly contentType!: KladrContentType;
  private readonly fullName!: string;
  private readonly guid!: string;
  private readonly ifnsfl!: string;
  private readonly ifnsul!: string;
  private readonly oktmo!: string;
  private readonly parentGuid!: string;
  private readonly cadnum!: string;
  @Type(() => KladrSubject)
  private readonly parents: KladrSubject[] = [];

  public getId(): string {
    return this.id;
  }

  public get displayName(): string {
    return [
      ...this
        .parents
        .filter(parent => !['cityOwner'].includes(parent.getContentType()))
        .map(parent => {
          if (parent.contentType === 'region') {
            return `${parent.name} ${parent.typeShort}.`;
          }
          return `${parent.typeShort}. ${parent.name}`;
        }),
      `${this.typeShort}. ${this.name}`
    ].join(', ');
  }

  public getTypeShort(): string {
    return this.typeShort;
  }

  public getFullName(): string {
    return this.fullName;
  }

  public getZip(): number {
    return this.zip;
  }

  public getParents(): KladrSubject[] {
    return this.parents;
  }

  public getContentType(): KladrContentType {
    return this.contentType;
  }

  public get isBuilding(): boolean {
    return this.getContentType() === KladrContentType.BUILDING;
  }

  public get isStreet(): boolean {
    return this.getContentType() === KladrContentType.STREET;
  }

  public getName(): string {
    return this.name;
  }

  public getParentStreet(): KladrSubject | undefined {
    return this.parents.find((subject) => subject.isStreet);
  }
}
